export default __webpack_public_path__ + "static/media/Int_BUK.9ab2406b.svg";